import { StyleSheet } from 'react-native'
import { fontFamily } from '../../../../theme'
import { moderateScale } from '../../../../styles/sizes'

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  blind: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 80
  },
  value: {
    color: 'white',
    fontFamily: fontFamily.GTAmericaExtended,
    fontSize: moderateScale(12),
    textTransform: 'uppercase'
  },
  title: {
    color: 'white',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    fontSize: moderateScale(12),
    textTransform: 'uppercase'
  }
})
